// import React, { useEffect, useState } from 'react';
// import '../../App.css';
// import l1 from '../Images/Chatbot.jpeg';


// const Modal = ({ isOpen, onClose, onSubmit }) => {
//     const [mobileNumber, setMobileNumber] = useState('');

//     const handleSubmit = () => {
//         if (mobileNumber) {
//             onSubmit(mobileNumber);
//         } else {
//             alert('Please enter a valid mobile number.');
//         }
//     };

//     return (
//         isOpen && (
//             <div className="modal" style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(0, 0, 0, 0.5)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000, }}>
//                 <div className="modal-content" style={{ backgroundColor: 'white', padding: '30px', borderRadius: '8px', boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)', width: '90%', maxWidth: '400px', textAlign: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '20px', }}>
//                     <span className="close" onClick={onClose} style={{ position: 'absolute', top: '10px', right: '10px', fontSize: '24px', cursor: 'pointer', color: '#333', }}>&times;</span>
//                     <h2>Enter Your Mobile Number</h2>
//                     <input type="text" placeholder="Enter mobile number" value={mobileNumber} onChange={(e) => setMobileNumber(e.target.value)} style={{ padding: '12px 20px', fontSize: '16px', width: '100%', maxWidth: '300px', marginBottom: '20px', border: '1px solid #ccc', borderRadius: '5px', outline: 'none', boxSizing: 'border-box', transition: 'border-color 0.3s ease', }} />
//                     <button onClick={handleSubmit} style={{ padding: '12px 20px', backgroundColor: '#007bff', color: 'white', border: 'none', borderRadius: '5px', cursor: 'pointer', fontSize: '16px', width: '100%', maxWidth: '300px', transition: 'background-color 0.3s ease', }}>Submit</button>
//                 </div>
//             </div>
//         )
//     );
// };


// // Header Component
// const Header = () => {
//     const [solutionsDropdownVisible, setSolutionsDropdownVisible] = useState(false);
//     const [demoFlowsDropdownVisible, setDemoFlowsDropdownVisible] = useState(false);
//     const [demoFlows, setDemoFlows] = useState([]);
//     const [selectedFlow, setSelectedFlow] = useState(null);
//     const [isModalOpen, setIsModalOpen] = useState(false);

//     const fetchflowconfig = () => {
//         fetch('https://rvapi.emedha.in/pages/api/api/eflowconfig')
//             .then((response) => response.json())
//             .then((data) => {
//                 setDemoFlows(data);
//             })
//             .catch((error) => {
//                 console.error('Error fetching demo flows:', error);
//             });
//     };

//     const handleFlowClick = (flow) => {
//         setSelectedFlow(flow);
//         setIsModalOpen(true);
//     };

//     const handleSubmit = (mobileNumber) => {
//         if (selectedFlow) {
//             const url = `https://emedha.com/echatbot/send_flow.php?id=${selectedFlow.id}&mobile=${mobileNumber}`;
//             fetch(url)
//                 .then(response => response.json())
//                 .then(data => {
//                     alert('Check your WhatsApp for further instructions.');
//                     setIsModalOpen(false);
//                 })
//                 .catch(error => {
//                     console.error('Error sending flow:', error);
//                     alert('There was an error processing your request.');
//                 });
//         }
//     };

//     useEffect(() => {
//         fetchflowconfig();
//     }, []);

//     const dropdownStyle = { position: 'absolute', top: '100%', left: 0, backgroundColor: 'white', border: '1px solid #ddd', boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)', zIndex: 10, display: 'flex', flexDirection: 'column', opacity: 0, transition: 'opacity 0.3s ease-in-out', minWidth: '200px', };

//     const dropdownLinkStyle = { padding: '10px 20px', textDecoration: 'none', color: '#333', fontSize: '16px', whiteSpace: 'nowrap', };

//     const hoverDropdownLinkStyle = { backgroundColor: 'none', color: '#007bff' };

//     const dropdownArrowStyle = { marginLeft: '5px', fontSize: '12px', transition: 'transform 0.3s ease-in-out' };

//     const openArrowStyle = { transform: 'rotate(180deg)' };

//     return (
//         <div className="header container" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', backgroundColor: '#fff', boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)' }}>

//             <img src={l1} alt="Logo" className="logo-img" style={{ width: '80px' }} />

//             <div className="nav-links" style={{ display: 'flex', gap: '30px', flexGrow: 1, justifyContent: 'center' }}>
//                 <a href="/" style={{ textDecoration: 'none', fontSize: '18px', color: '#333', fontWeight: 500, position: 'relative' }}><strong> Home</strong></a>

//                 <div className="solutions" style={{ position: 'relative' }} onMouseEnter={() => { setSolutionsDropdownVisible(true); setDemoFlowsDropdownVisible(false); }}
//                     onMouseLeave={() => setSolutionsDropdownVisible(false)}
//                 >
//                     <a href="/" style={{ textDecoration: 'none', fontSize: '18px', color: '#333', fontWeight: 500, position: 'relative' }}>
//                         <strong> Solutions</strong>
//                         <span className={`dropdown-arrow ${solutionsDropdownVisible ? 'open' : ''}`} style={{ ...dropdownArrowStyle, ...(solutionsDropdownVisible ? openArrowStyle : {}), }}></span></a>
//                     <div className="dropdown" style={{ ...dropdownStyle, opacity: solutionsDropdownVisible ? 1 : 0 }}>
//                         <a href="#Real-Estate" style={{ ...dropdownLinkStyle, ...(solutionsDropdownVisible ? hoverDropdownLinkStyle : {}) }}>Real Estate</a>
//                         <a href="/education-terms" style={{ ...dropdownLinkStyle, ...(solutionsDropdownVisible ? hoverDropdownLinkStyle : {}) }}>Education</a>
//                         <a href="/health-care" style={{ ...dropdownLinkStyle, ...(solutionsDropdownVisible ? hoverDropdownLinkStyle : {}) }}>Health Care</a>
//                         <a href="/Marketing-Terms" style={{ ...dropdownLinkStyle, ...(solutionsDropdownVisible ? hoverDropdownLinkStyle : {}) }}>Marketing Terms</a>
//                         <a href="/Sales-Terms" style={{ ...dropdownLinkStyle, ...(solutionsDropdownVisible ? hoverDropdownLinkStyle : {}) }}>Sales</a>
//                     </div>
//                 </div>

//                 <div className="demo-flow" style={{ position: 'relative' }} onMouseEnter={() => { setDemoFlowsDropdownVisible(true); setSolutionsDropdownVisible(false); }} onMouseLeave={() => setDemoFlowsDropdownVisible(false)}>
//                     <a href="#Demo-Flow" style={{ textDecoration: 'none', fontSize: '18px', color: '#333', fontWeight: 500, position: 'relative' }}>
//                         <strong>Demo Flow</strong>
//                     </a>
//                     <div className="dropdown" style={{ ...dropdownStyle, opacity: demoFlowsDropdownVisible ? 1 : 0 }}>
//                         {demoFlows.map((flow) => (
//                             <a key={flow.id} onClick={() => handleFlowClick(flow)} style={{ ...dropdownLinkStyle, ...(demoFlowsDropdownVisible ? hoverDropdownLinkStyle : {}) }} >
//                                 {flow.display_name}
//                             </a>
//                         ))}
//                     </div>
//                 </div>

//                 <a href="#Resources" style={{ textDecoration: 'none', fontSize: '18px', color: '#333', fontWeight: 500, position: 'relative' }}><strong>Resources</strong></a>
//             </div>

//             <div className="book-demo" style={{ display: 'flex', justifyContent: 'flex-end' }}>
//                 <button className="book-demo-btn" style={{ padding: '10px 20px', backgroundColor: '#007bff', color: 'white', border: 'none', borderRadius: '5px', cursor: 'pointer', fontSize: '16px' }}>
//                     Book Demo
//                 </button>
//             </div>

//             <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} onSubmit={handleSubmit} />
//         </div>
//     );
// };

// export default Header;



// import React, { useEffect, useState } from 'react';
// import '../../App.css';
// import l1 from '../Images/Chatbot.jpeg';
// import { Navbar, Nav, NavDropdown, Button, Container } from 'react-bootstrap';

// const Modal = ({ isOpen, onClose, onSubmit }) => {
//     const [mobileNumber, setMobileNumber] = useState('');

//     const handleSubmit = () => {
//         if (mobileNumber) {
//             onSubmit(mobileNumber);
//         } else {
//             alert('Please enter a valid mobile number.');
//         }
//     };

//     return (
//         isOpen && (
//             <div className="modal" style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(0, 0, 0, 0.5)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000 }}>
//                 <div className="modal-content" style={{ backgroundColor: 'white', padding: '30px', borderRadius: '8px', boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)', width: '90%', maxWidth: '400px', textAlign: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '20px' }}>
//                     <span className="close" onClick={onClose} style={{ position: 'absolute', top: '10px', right: '10px', fontSize: '24px', cursor: 'pointer', color: '#333' }}>&times;</span>
//                     <h2>Enter Your Mobile Number</h2>
//                     <input type="text" placeholder="Enter mobile number" value={mobileNumber} onChange={(e) => setMobileNumber(e.target.value)} style={{ padding: '12px 20px', fontSize: '16px', width: '100%', maxWidth: '300px', marginBottom: '20px', border: '1px solid #ccc', borderRadius: '5px', outline: 'none', boxSizing: 'border-box', transition: 'border-color 0.3s ease' }} />
//                     <button onClick={handleSubmit} style={{ padding: '12px 20px', backgroundColor: '#007bff', color: 'white', border: 'none', borderRadius: '5px', cursor: 'pointer', fontSize: '16px', width: '100%', maxWidth: '300px', transition: 'background-color 0.3s ease' }}>Submit</button>
//                 </div>
//             </div>
//         )
//     );
// };

// const Header = () => {
//     const [demoFlows, setDemoFlows] = useState([]);
//     const [selectedFlow, setSelectedFlow] = useState(null);
//     const [isModalOpen, setIsModalOpen] = useState(false);

//     const fetchflowconfig = () => {
//         fetch('https://rvapi.emedha.in/pages/api/api/eflowconfig')
//             .then((response) => response.json())
//             .then((data) => {
//                 setDemoFlows(data);
//             })
//             .catch((error) => {
//                 console.error('Error fetching demo flows:', error);
//             });
//     };

//     const handleFlowClick = (flow) => {
//         setSelectedFlow(flow);
//         setIsModalOpen(true);
//     };

//     const handleSubmit = (mobileNumber) => {
//         if (selectedFlow) {
//             const url = `https://emedha.com/echatbot/send_flow.php?id=${selectedFlow.id}&mobile=${mobileNumber}`;
//             fetch(url)
//                 .then(response => response.json())
//                 .then(data => {
//                     alert('Check your WhatsApp for further instructions.');
//                     setIsModalOpen(false);
//                 })
//                 .catch(error => {
//                     console.error('Error sending flow:', error);
//                     alert('There was an error processing your request.');
//                 });
//         }
//     };

//     useEffect(() => {
//         fetchflowconfig();
//     }, []);

//     return (
//         <Navbar expand="lg" bg="light" variant="light" className="shadow-sm">
//             <Container>
//                 <Navbar.Brand href="/">
//                     <img src={l1} alt="Logo" style={{ width: '80px' }} />
//                 </Navbar.Brand>
//                 <Navbar.Toggle aria-controls="navbar-nav" />
//                 <Navbar.Collapse id="navbar-nav">
//                     <Nav className="ms-auto d-flex justify-content-center w-100">
//                         <Nav.Link href="/" className="text-black"><strong>Home</strong></Nav.Link>
//                         <NavDropdown title={<span className="text-black"><strong>Solutions</strong></span>} id="solutions-dropdown">
//                             <NavDropdown.Item href="#Real-Estate">Real Estate</NavDropdown.Item>
//                             <NavDropdown.Item href="/education-terms">Education</NavDropdown.Item>
//                             <NavDropdown.Item href="/health-care">Health Care</NavDropdown.Item>
//                             <NavDropdown.Item href="/Marketing-Terms">Marketing Terms</NavDropdown.Item>
//                             <NavDropdown.Item href="/Sales-Terms">Sales</NavDropdown.Item>
//                         </NavDropdown>                    
//                         <Nav.Link className="text-black" href="#Resources"><strong>Resources</strong></Nav.Link>
//                     </Nav>
//                     <Nav.Item className="ms-auto">
//                         <Button className="text-black" variant="primary">Book Demo</Button>
//                     </Nav.Item>
//                 </Navbar.Collapse>
//             </Container>     
//         </Navbar>

//     );
// };

// export default Header;




import React, { useState, useEffect } from 'react';
import './Header.css';
import l1 from '../Images/Chatbot.jpeg';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Modal, Button, Form } from 'react-bootstrap';
import { FaUserAlt, FaPhoneAlt, FaEnvelope, FaCity, FaBuilding, FaIndustry } from 'react-icons/fa';
import { City, State } from 'country-state-city';
import Select from 'react-select';

const Header = () => {
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    mobile: '',
    email: '',
    city: '',
    companyName: '',
    businessVertical: '',
  });
  const [cities, setCities] = useState([]);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const initialFormData = {
    name: '',
    mobile: '',
    email: '',
    city: '',
    companyName: '',
    businessVertical: '',
  };

  useEffect(() => {
    const statesOfIndia = State.getStatesOfCountry('IN');
    const allCities = [];
    statesOfIndia.forEach((state) => {
      const citiesInState = City.getCitiesOfState('IN', state.isoCode);
      allCities.push(...citiesInState);
    });
    setCities(allCities);
  }, []);

  const handleShowModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleCityChange = (selectedCity) => {
    setFormData((prevState) => ({
      ...prevState,
      city: selectedCity ? selectedCity.value : '',
    }));
  };

  // const handleSubmit = async (e) => {
  //   e.preventDefault();

  //   try {
  //     const response = await fetch('http://localhost:4002/pages/api/bookdemo/submit-form', {
  //       method: 'POST',
  //       headers: {
  //         'Content-Type': 'application/json',
  //       },
  //       body: JSON.stringify(formData),
  //     });

  //     let data;
  //     try {
  //       data = await response.json();
  //     } catch (error) {
  //       data = { message: 'Non-JSON response received' };
  //       console.error('Response is not valid JSON:', error);
  //     }

  //     console.log('Response Status:', response.status);
  //     console.log('Response Data:', data);

  //     if (response.ok) {
  //       alert('Form submitted successfully!');
  //       setFormData(initialFormData);
  //       handleCloseModal();
  //     } else {
  //       alert(`Error submitting form. Status: ${response.status}, Message: ${data.message || 'Unknown error'}`);
  //     }
  //   } catch (error) {
  //     console.error('Error:', error);
  //     alert('Error submitting form');
  //   }
  // };

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    try {
      // First API Call (Submit form data to your backend)
      const response = await fetch('https://rvapi.emedha.in/pages/api/bookdemo/submit-form', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });
  
      let data;
      try {
        data = await response.json();
      } catch (error) {
        data = { message: 'Non-JSON response received' };
        console.error('Response is not valid JSON:', error);
      }
  
      console.log('Response Status:', response.status);
      console.log('Response Data:', data);
  
      if (response.ok) {
        alert('Form submitted successfully!');
  
        // Second API Call (Send data to the "thanks.php" API)
        const secondApiResponse = await fetch(`https://emedha.com/echatbot/thanks.php?mobile=${formData.mobile}&name=${formData.name}`);
        
        // Optionally check the second API response status or data
        if (secondApiResponse.ok) {
          console.log('Second API call was successful.');
        } else {
          console.error('Second API call failed:', secondApiResponse.status);
        }
  
        // Reset form data after success
        setFormData(initialFormData);
        handleCloseModal();
      } else {
        alert(`Error submitting form. Status: ${response.status}, Message: ${data.message || 'Unknown error'}`);
      }
    } catch (error) {
      console.error('Error:', error);
      alert('Error submitting form');
    }
  };
  

  const cityOptions = cities.map((city) => ({
    value: city.name,
    label: city.name,
  }));

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };


  const [demoFlows, setDemoFlows] = useState([]);
  const [showFlows, setShowFlows] = useState(false);

  const fetchflowconfig = () => {
    fetch('https://rvapi.emedha.in/pages/api/api/eflowconfig')
      .then((response) => response.json())
      .then((data) => {
        setDemoFlows(data);
      })
      .catch((error) => {
        console.error('Error fetching demo flows:', error);
      });
  };

  const handleImageClick = () => {
    if (!showFlows) {
      fetchflowconfig();
    }
    setShowFlows(!showFlows);
  };


  useEffect(() => {
    fetchflowconfig();
  }, []);


  const [selectedFlow, setSelectedFlow] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [mobileNumber, setMobileNumber] = useState('');

  const handleSubmitFlow = () => {
    if (selectedFlow) {
      const url = `https://emedha.com/echatbot/send_flow.php?id=${selectedFlow.id}&mobile=${mobileNumber}`;
      fetch(url)
        .then(response => response.json())
        .then(data => {
          alert('Check your WhatsApp for further instructions.');
          setIsModalOpen(false);
        })
        .catch(error => {
          console.error('Error sending flow:', error);
          alert('There was an error processing your request.');
        });
    }
  };

  const handleFlowClick = (flow) => {
    setSelectedFlow(flow);
    setIsModalOpen(true);
  };


  return (
    <div className="navbar-container mt-2">
      <nav className="navbar">
        <img src={l1} alt="Logo" style={{ width: '80px', borderRadius: '50px' }} />
        <button className="navbar-toggle" onClick={toggleMobileMenu}>&#9776; </button>
        <ul className={`navbar-links ${isMobileMenuOpen ? 'open' : ''}`}>
          <li className="navbar-dropdown">
            <a href="/">Home</a>
          </li>
          <li className="navbar-dropdown">
            <a href="#">Solutions</a>
            <div className="dropdown">
              <a href="#">Real Estate</a>
              <a href="/education-terms">Education</a>
              <a href="/health-care">Health Care</a>
              <a href="/Marketing-Terms">Marketing Terms</a>
              <a href="/Sales-Terms">Sales</a>
            </div>
          </li>
          <li className="navbar-dropdown">
            <a href="#">Resources</a>
          </li>
          <li className="navbar-dropdown">
            <a href="#" onClick={handleImageClick}>Sample Flow</a>
            <a className="dropdown">
              {demoFlows.map((flow) => (
                <li key={flow.id}>
                  <a href="#" onClick={() => handleFlowClick(flow)}>{flow.display_name}</a>
                </li>
              ))}
            </a>
          </li>
        </ul>
        <button className="book-demo" onClick={handleShowModal}>
          Book Demo
        </button>
      </nav>

      {/* Modal */}
      <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>Book a Demo</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ backgroundColor: '#d8dfe0' }}>
          <Form onSubmit={handleSubmit}>
            <Form.Group controlId="formName">
              <Form.Label><FaUserAlt /> Name</Form.Label>
              <Form.Control type="text" placeholder="Enter your name" name="name" value={formData.name} onChange={handleInputChange} style={{ border: '2px solid black' }} />
            </Form.Group>

            <Form.Group controlId="formMobile">
              <Form.Label><FaPhoneAlt /> Mobile</Form.Label>
              <Form.Control type="text" placeholder="Enter your mobile number" name="mobile" value={formData.mobile} onChange={handleInputChange} style={{ border: '2px solid black' }} />
            </Form.Group>

            <Form.Group controlId="formEmail">
              <Form.Label><FaEnvelope /> Email</Form.Label>
              <Form.Control type="email" placeholder="Enter your email" name="email" value={formData.email} onChange={handleInputChange} style={{ border: '2px solid black' }} />
            </Form.Group>

            <Form.Group controlId="formCity">
              <Form.Label><FaCity /> City</Form.Label>
              <Select options={cityOptions} value={cityOptions.find(option => option.value === formData.city)} onChange={handleCityChange} placeholder="Select your city" isClearable />
            </Form.Group>

            <Form.Group controlId="formCompanyName">
              <Form.Label><FaBuilding /> Company Name</Form.Label>
              <Form.Control type="text" placeholder="Enter your company name" name="companyName" value={formData.companyName} onChange={handleInputChange} style={{ border: '2px solid black' }} />
            </Form.Group>

            <Form.Group controlId="formBusinessVertical">
              <Form.Label><FaIndustry /> Business Vertical</Form.Label>
              <Form.Control type="text" placeholder="Enter your business vertical" name="businessVertical" value={formData.businessVertical} onChange={handleInputChange} style={{ border: '2px solid black' }} />
            </Form.Group>

            <Button className="mt-2" style={{ backgroundColor: "#008CBA", border: '2px solid black' }} type="submit">
              Submit
            </Button>
          </Form>
        </Modal.Body>
      </Modal>

      {isModalOpen && (
        <div className="modal" style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(0, 0, 0, 0.5)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000 }}>
          <div className="modal-content" style={{ backgroundColor: '#d8dfe0', padding: '30px', borderRadius: '8px', boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)', width: '90%', maxWidth: '400px', textAlign: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '20px' }}>
            <span className="close" onClick={() => setIsModalOpen(false)} style={{ position: 'absolute', top: '10px', right: '10px', fontSize: '24px', cursor: 'pointer', color: '#333' }}>&times;</span>
            <h2>Enter Your Mobile Number</h2>
            <input type="text" placeholder="Enter mobile number" value={mobileNumber} onChange={(e) => setMobileNumber(e.target.value)} style={{ padding: '12px 20px', fontSize: '16px', width: '100%', maxWidth: '300px', marginBottom: '20px', border: '1px solid #ccc', borderRadius: '5px', outline: 'none', boxSizing: 'border-box', transition: 'border-color 0.3s ease' }} />
            <button onClick={handleSubmitFlow} style={{ padding: '12px 20px', backgroundColor: '#007bff', color: 'white', border: 'none', borderRadius: '5px', cursor: 'pointer', fontSize: '16px', width: '100%', maxWidth: '300px', transition: 'background-color 0.3s ease' }}>Submit</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Header;




